import {
  AfterContentChecked,
  AfterContentInit,
  AfterViewInit, ChangeDetectionStrategy,
  Component,
  DoCheck,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MultiSelectComponent} from '@syncfusion/ej2-angular-dropdowns';

@Component({
  selector: 'ui-select-multi',
  templateUrl: './select.component.html',
  encapsulation: ViewEncapsulation.None
})
export class SelectMultiComponent  implements  OnInit {
  @Input() defaultValue: number[] = [];
  @Input() placeHolder: string;
  @Input() id: string = 'slId';
  @Input() fieldName: string = 'name';
  @Input() fieldValue: string = 'value';
  public fieldTree: Object;
  @Input() data: Object[] = [];
  @Input() allowMulti: boolean = false;
  @ViewChild('multiSelect')
  public selectMulti: MultiSelectComponent;
  constructor(

  ) {

  }
  ngOnInit(): void {
    this.fieldTree = {text: this.fieldName, value: this.fieldValue};
    setTimeout(() => {
      this.selectMulti.value=  this.defaultValue;
    }, 1000);
  }
}
